<template>
	<div class="master-companies">
		<action-sidebar
			title="Proyectos"
			:value="true"
			:width="500"
			@close-modal="closeModal"
		>
			<v-tabs 
				v-model="tabsModel"
				right
				slider-color="cyan">
				<v-tab v-for="(item, index) in tabs" :key="index">
					{{item.name}}
				</v-tab>
				<v-tabs-items>
					<v-tab-item>
						<table-master-companies
                            :check-all="checkAll" 
                            :columns="columns"
                            :rows="companies"
                            :selected-value="selectedValue"
                            :last-page="lastPageAssigned"
                            :current-page="currentPageAssigned"
                            @all-is-selected="allIsSelected"
                            @on-search="onSearchList"
                            @row-is-selected="rowIsSelected"
                            @change-page="changePageAssigned"
						/>
					</v-tab-item>
					<v-tab-item>
						<table-master-companies
							:check-all="checkAllDeallocated"
							:columns="columns"
							:rows="companiesListAssigned"
							:last-page="lastPage"
							:current-page="currentPage"
							:selected-value="selectedValueDeallocated"
							@change-page="changePage"
							@on-search="onSearchDeallocated"
							@all-is-selected="allIsSelectedDeallocated"
							@row-is-selected="rowIsSelectedDeallocated"
						/>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
			<section class="modal-filter-footer pt-4 pb-4 center-buttons">
				<v-btn
				class="btn-action caption ml-2" 
				color="pink"
				@click="closeModal">
					Cancelar
				</v-btn>
				<v-btn
				class="btn-action caption ml-1"
				color="success"
				@click="assignRow"
				:disabled="disabledProject(1)">
					Asignar
				</v-btn>
				<v-btn 
				class="btn-action caption ml-2" 
				color="success"
				:disabled="disabledDeallocated(0)"
				@click="deallocateButton">
					Desasignar
				</v-btn>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import tableMasterCompanies from '@/components/configuration/table-master-companies';

function created() {
	this.companiesList();
	this.companiesListDeallocated();
}

async function deallocateButton() {
	const companiesIds = this.dataSelectedDeallocated.map(item => item.id);
	const body = { companiesIds };
	const url = `distributaries/${this.id}/company-parent`;
	try {
		await this.$http.delete(url, { data: body });
		this.companiesListDeallocated();
		this.closeModal();
		this.showNotification('Fueron desasignados correctamente');
	} catch (error) {
		this.showError();
	}
}

function changePageAssigned(page) {
	this.params.page = page;
	this.currentPageAssigned = page;
	this.companiesList();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.companiesListDeallocated();
}

function closeModal() {
	this.goTo('page-dealers-projects');
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocated < 1;
}

function disabledProject(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

async function assignRow() {
	const companiesIds = this.dataSelected.map(action => action.id);
	const url = `distributaries/${this.id}/company-parent`;
	try {
		await this.$http.post(url, { companiesIds });
		this.companiesList();
		this.closeModal();
		this.showNotification('Los proyectos fueron asignados correctamente');
	} catch (error) {
		this.showError();
	}
}

function onSearchList(value) {
	this.params.search = value ? value.trim() : null;
	this.companiesList();
}

function onSearchDeallocated(search) {
	this.params.search = search ? search.trim() : null;
	this.companiesListDeallocated();
}

function allIsSelectedDeallocated(checked) {
	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.companiesListAssigned = this.companiesListAssigned.map((item) => {
		const newRowDeallocated = { ...item };
		newRowDeallocated.isSelected = checked;
		if (checked) {
			this.dataSelectedDeallocated.push(item);
		}
		return newRowDeallocated;
	});
	this.companiesListAssigned = this.selectIsRow(this.companiesListAssigned,
		this.selectedValueDeallocated, false, checked);
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.companies = this.companies.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(element);
		}
		return newRow;
	});
	this.companies = this.selectIsRow(this.companies, this.selectedValue, false, checked);
}

function rowIsSelected(row) {
	this.companies = this.selectIsRow(this.companies, this.selectedValue, row);
	this.checkAll = this.every(this.companies, this.selectedValue);
	this.dataSelected = this.companies.filter(r => r.flagSelected);
}

function rowIsSelectedDeallocated(row) {
	this.companiesListAssigned = this.selectIsRow(
		this.companiesListAssigned, this.selectedValueDeallocated, row);
	this.checkAll = this.every(this.companiesListAssigned, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.companiesListAssigned.filter(r => r.flag);
}

async function companiesList() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 30,
		isSelected: 0,
	};
	const url = `/projects/${this.codeProject}/distributaries/${this.id}/company-parent`;
	try {
		const response = await this.$http.get(url, { params });
		this.companies = response.data.data;
		this.lastPageAssigned = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

async function companiesListDeallocated() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 30,
		isSelected: 1,
	};
	const url = `/projects/${this.codeProject}/distributaries/${this.id}/company-parent`;
	try {
		const response = await this.$http.get(url, { params });
		this.companiesListAssigned = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0,
		},
		checkAll: false,
		checkAllDeallocated: false,
		columns: [
			{ id: 1, name: 'Nombre', value: 'nombreComercial', checked: true, visible: true },
			{ id: 2, name: 'Razón social', value: 'razonSocial', checked: true, visible: true },
			{ id: 3, name: 'RUC', value: 'ruc', checked: true, visible: true },
			{ id: 4, name: 'Código', value: 'codeCompany', checked: true, visible: true },
		],
		currentPage: 1,
		currentPageAssigned: 1,
		dataSelected: [],
		dataSelectedDeallocated: [],
		lastPage: 0,
		lastPageAssigned: 0,
		rowAssigned: [],
		params: {
			page: 1,
		},
		companiesListAssigned: [],
		projectId: null,
		companies: [],
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
		tabsModel: null,
		selectedValue: 'flagSelected',
		selectedValueDeallocated: 'flag',
	};
}

export default {
	name: 'page-projects',
	created,
	data,
	components: {
		actionSidebar,
		tableMasterCompanies,
	},
	methods: {
		rowIsSelectedDeallocated,
		allIsSelectedDeallocated,
		allIsSelected,
		assignRow,
		changePage,
		changePageAssigned,
		closeModal,
		deallocateButton,
		disabledDeallocated,
		disabledProject,
		companiesList,
		companiesListDeallocated,
		rowIsSelected,
		onSearchList,
		onSearchDeallocated,
	},
	props: {
		codeProject: {
			type: [Number, String],
		},
		id: {
			type: Number,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.center-buttons {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-master-companies.vue